import React from "react";

import { CardContent } from "@material-ui/core";

import { Loader } from "../index";

export interface BodyProps {
  children: React.ReactNode;
  loading?: boolean;
}

export default function Body({ children, loading }: BodyProps) {
  return (
    <CardContent>
      <Loader loading={loading}>{children}</Loader>
    </CardContent>
  );
}
